import { useEffect } from "react";
import { css } from "goober";

import mainRefs from "@/__main__/refs.mjs";
import { useGameInfo } from "@/util/game-route.mjs";

export const useGameAccentStyle = () => {
  const gameInfo = useGameInfo();

  useEffect(() => {
    const injectClass = css`
      --game-accent-color: ${gameInfo?.gameColor || "var(--primary)"};
    `;

    let isMounted = true;

    queueMicrotask(() => {
      if (isMounted) {
        mainRefs.externalContainerClasses.add(injectClass);
      }
    });

    return () => {
      isMounted = false;

      mainRefs.externalContainerClasses.delete(injectClass);
    };
  }, [gameInfo]);
};
